export const IE_COUNTIES: { [key: string]: string } = Object.freeze({
  CW: 'Carlow',
  CN: 'Cavan',
  CE: 'Clare',
  CO: 'Cork',
  DL: 'Donegal',
  D: 'Dublin',
  G: 'Galway',
  KY: 'Kerry',
  KE: 'Kildare',
  KK: 'Kilkenny',
  LS: 'Laois',
  LM: 'Leitrim',
  LK: 'Limerick',
  LD: 'Longford',
  LH: 'Louth',
  MO: 'Mayo',
  MH: 'Meath',
  MN: 'Monaghan',
  OY: 'Offaly',
  RN: 'Roscommon',
  SO: 'Sligo',
  TA: 'Tipperary',
  WD: 'Waterford',
  WH: 'Westmeath',
  WX: 'Wexford',
  WW: 'Wicklow',
});

export const AU_STATES: { [key: string]: string } = Object.freeze({
  ACT: 'Australian Capital Territory',
  NSW: 'New South Wales',
  NT: 'Northern Territory',
  QLD: 'Queensland',
  SA: 'South Australia',
  TAS: 'Tasmania',
  VIC: 'Victoria',
  WA: 'Western Australia',
});

export const US_STATES: { [key: string]: string } = Object.freeze({
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  DC: 'District Of Columbia',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
});

// this maps to a translation key because we possibly need French
export const CA_PROVINCES: { [key: string]: string } = Object.freeze({
  AB: 'ca.province.alberta',
  BC: 'ca.province.british_columbia',
  MB: 'ca.province.manitoba',
  NB: 'ca.province.new_brunswick',
  NL: 'ca.province.newfoundland_and_labrador',
  NT: 'ca.province.northwest_territories',
  NS: 'ca.province.nova_scotia',
  NU: 'ca.province.nunavut',
  ON: 'ca.province.ontario',
  PE: 'ca.province.prince_edward_island',
  QC: 'ca.province.quebec',
  SK: 'ca.province.saskatchewan',
  YT: 'ca.province.yukon',
});

//  I18n.with_locale(:ja) { Square::Countries.find_country('JP').states }.freeze
export const JP_PREFECTURES: {
  [key: string]: string;
} = Object.freeze({
  '01': '北海道',
  '02': '青森県',
  '03': '岩手県',
  '04': '宮城県',
  '05': '秋田県',
  '06': '山形県',
  '07': '福島県',
  '08': '茨城県',
  '09': '栃木県',
  '10': '群馬県',
  '11': '埼玉県',
  '12': '千葉県',
  '13': '東京都',
  '14': '神奈川県',
  '15': '新潟県',
  '16': '富山県',
  '17': '石川県',
  '18': '福井県',
  '19': '山梨県',
  '20': '長野県',
  '21': '岐阜県',
  '22': '静岡県',
  '23': '愛知県',
  '24': '三重県',
  '25': '滋賀県',
  '26': '京都府',
  '27': '大阪府',
  '28': '兵庫県',
  '29': '奈良県',
  '30': '和歌山県',
  '31': '鳥取県',
  '32': '島根県',
  '33': '岡山県',
  '34': '広島県',
  '35': '山口県',
  '36': '徳島県',
  '37': '香川県',
  '38': '愛媛県',
  '39': '高知県',
  '40': '福岡県',
  '41': '佐賀県',
  '42': '長崎県',
  '43': '熊本県',
  '44': '大分県',
  '45': '宮崎県',
  '46': '鹿児島県',
  '47': '沖縄県',
});

export const ADJUSTMENT_TYPES: { [key: string]: string } = Object.freeze({
  line_item: 'checkout.receipt.label.productDiscount',
  order: 'checkout.receipt.label.cartDiscount',
  shipment: 'checkout.receipt.label.freeShipping',
});

export const PAYMENT_RESPONSE_ERRORS: { [key: string]: string } = Object.freeze(
  {
    PAYMENT_ALREADY_CHARGED: 'Payment already charged',
    PAYMENT_REQUIRED: 'Payment required',
    PAYMENT_FAILED: 'Payment failed',
    CARD_DETAILS_REQUIRED: 'Card details required',
    ISSUER_INSTALLMENT_ERROR: 'Issuer installment error',
    CUSTOMER_CREATION_FAILED: 'Customer creation failed',
    CARD_CREATION_FAILED: 'Card creation failed',
    INSTRUMENT_VERIFICATION_FAILED: 'Instrument verification failed',
    CARD_MIGRATION_FAILED: 'Card migration failed',
  },
);
